export default __webpack_public_path__ + "static/media/iconeRequisitosPorEscopo.cea23a9f.png";